import Article from './Article';

export { default as ArticleTheme } from './Article.style';
export default Article;
